module.exports = __webpack_public_path__ + "static/media/ANALISTA.83cd80e6.png";